module.exports = __webpack_public_path__ + "static/battle05-sq-e8632c93d2e14dd5411cdb23e897e226.png";